require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuung-10-14-betreuungseinrichtungen-neusiedl-zurndorf.json") })
        }
      }, "path---betreuung-10-14-betreuungseinrichtungen-neusiedl-zurndorf");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuung-10-14-betreuungseinrichtungen-neusiedl-zurndorf!./.cache/json/betreuung-10-14-betreuungseinrichtungen-neusiedl-zurndorf.json
// module id = 784
// module chunks = 231608221292675